<template>
    <div id="app-aside" class="z-[70] sticky top-0 self-start bg-primary-3 text-content-inverse-1 w-[220px] h-screen transition-all duration-500 " :class="{ 'p-0': !show, 'w-[56px]': !show }">
        <div class="h-[4rem] px-4">
            <div class="w-full h-full flex justify-center items-center border-b border-primary-2">
                <img v-if="show" src="@/assets/img/hrnflex_wh_logo.png" alt="white_logo" class="h-[1.125rem]" />
            </div>
        </div>
        <div class="mt-[1.25rem] pb-[1.5rem] aside-scroll"  :class="{ 'p-0': !show, 'px-[0.75rem]': show }">
            <!-- 메뉴 열림 (open) -->
            <template v-if="show">
                <template v-for="(item, index) in items" v-bind:key="index">
                    <a
                        v-if="!item.noPermission"
                        v-show="!item.parent || item.show"
                        class="flex w-full h-[2.5rem] px-[0.75rem] rounded-2 items-center hover:bg-transparent-basic-1 transition-all duration-500 cursor-pointer"
                        :class="{ 'mt-1': index > 0, 'bg-transparent-basic-1': item['isCurrentHref'] || isCollapsedAndHasCurrentChild(item) }"
                        @click="clickIcon(item)">
                        <DashboardIcon
                            v-if="item.img === 'dashboard'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <GroupIcon
                            v-else-if="item.img === 'team'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <PaceIcon
                            v-else-if="item.img === 'attendance'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <FlightTakeOffIcon
                            v-else-if="item.img === 'flight-take-off'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <DescriptionIcon
                            v-else-if="item.img === 'description'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <FeaturedSeasonalAndGiftsIcon
                            v-else-if="item.img === 'flexben'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <!-- === shell전용 메뉴 === -->
                        <FeaturedSeasonalAndGiftsIcon
                            v-else-if="item.img === 'flexben-shell'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <!-- ========================= -->
                        <PaidIcon
                            v-else-if="item.img === 'paid'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <SettingsIcon
                            v-else-if="item.img === 'settings'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <span 
                            class="flex-1 w-full ml-2 whitespace-nowrap font-body-sm-medium" 
                            :class="{ 'ml-4': !item.img, 'font-caption-md-semibold': item.parent }"
                            v-html="item.text">
                        </span>
                        <ExpandLessIcon
                            v-if="item.children && items.find((item2) => item2.parent === item.img && item2.show)"
                            :width="12"
                            :height="12"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <ExpandMoreIcon
                            v-if="item.children && items.find((item2) => item2.parent === item.img && !item2.show)"
                            :width="12"
                            :height="12"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                    </a>
                </template>
            </template>

            <!--메뉴 닫힘 (fold)-->
            <template v-if="!show">
                <template v-for="(item, index) in items" v-bind:key="index">
                    <a
                        v-if="!item.noPermission"
                        v-show="!item.parent"
                        class="w-[2.5rem] h-[2.5rem] mx-2 rounded-2 flex items-center justify-center hover:bg-transparent-basic-1 transition-all duration-500 cursor-pointer"
                        :class="{ 'mt-1': index > 0, 'bg-transparent-basic-1': isActiveParentMenu(item) }"
                        @click="clickIcon(item)">
                        <DashboardIcon
                            v-if="item.img === 'dashboard'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <GroupIcon
                            v-else-if="item.img === 'team'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <PaceIcon
                            v-else-if="item.img === 'attendance'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <FlightTakeOffIcon
                            v-else-if="item.img === 'flight-take-off'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <DescriptionIcon
                            v-else-if="item.img === 'description'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <FeaturedSeasonalAndGiftsIcon
                            v-else-if="item.img === 'flexben'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <!-- === shell전용 메뉴 === -->
                        <FeaturedSeasonalAndGiftsIcon
                            v-else-if="item.img === 'flexben-shell'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <!-- ========================= -->
                        <PaidIcon
                            v-else-if="item.img === 'paid'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <SettingsIcon
                            v-else-if="item.img === 'settings'"
                            :width="20"
                            :height="20"
                            color="text-content-inverse-1"
                            weight="REGULAR"
                        />
                        <!-- <span class="flex-1 ml-4 whitespace-nowrap" :class="{ 'ml-12': !item.img }"></span> -->
                    </a>
                </template>
            </template>
        </div>
    </div>
    <Teleport to="body">
        <a
            class="z-[70] fixed top-4 flex justify-center items-center transition-all duration-500 cursor-pointer hover:bg-transparent-basic-1 rounded-full"
            :class="[show ? 'translate-x-[208px]' : 'translate-x-4']"
            href="javascript:void(0)"
            @click="toggleMenu">
            <img class="rounded-full shadow-md border-0" :class="{ 'rotate-180': !show }" src="@/assets/img/app-side-9.svg" alt="app-side-9" />
        </a>
    </Teleport>
</template>

<script setup>
import { ref, reactive, onMounted, inject } from 'vue';
import DashboardIcon from '@/components/design-system/icon/dashboard.vue';
import GroupIcon from '@/components/design-system/icon/group.vue';
import PaceIcon from '@/components/design-system/icon/pace.vue';
import FlightTakeOffIcon from '@/components/design-system/icon/flight-take-off.vue';
import DescriptionIcon from '@/components/design-system/icon/description.vue';
import FeaturedSeasonalAndGiftsIcon from '@/components/design-system/icon/featured-seasonal-and-gifts.vue';
import PaidIcon from '@/components/design-system/icon/paid.vue';
import SettingsIcon from '@/components/design-system/icon/settings.vue';
import ExpandLessIcon from '@/components/design-system/icon/expand-less.vue';
import ExpandMoreIcon from '@/components/design-system/icon/expand-more.vue';
const { checkPermission, checkSubscription } = inject('appUtil');

const show = ref(true);

const hrnflexPages = reactive([
    {
        href: '/hrDashboard',
        img: 'dashboard',
        text: 'Dashboard',
        noPermission: false,
    },
    {
        children: true,
        img: 'team',
        text: 'Team',
        noPermission: !checkPermission('TEAM_VIEW') && !checkPermission('TEAM_EDIT') && !checkPermission('TEAM_SETTING_VIEW') && !checkPermission('TEAM_SETTING_EDIT'),
    },
    {
        parent: 'team',
        show: false,
        href: checkPermission('TEAM_VIEW') || checkPermission('TEAM_EDIT') ? '/employees/employees' : '/employees/invited_employees',
        href_sub: ['/employees/invited_employees', '/employees/status-resigned-employees', '/employees/resigned_employees'],
        text: 'Employees',
        noPermission: !checkPermission('TEAM_VIEW') && !checkPermission('TEAM_EDIT') && !checkPermission('TEAM_SETTING_VIEW') && !checkPermission('TEAM_SETTING_EDIT'),
    },
    {
        parent: 'team',
        show: false,
        href: '/organization/department',
        href_sub: ['/organization/job_title'],
        text: 'Organization',
        noPermission: !checkPermission('TEAM_SETTING_VIEW') && !checkPermission('TEAM_SETTING_EDIT'),
    },
    {
        children: true,
        img: 'attendance',
        text: 'Attendance',
        noPermission: !checkPermission('ATTENDANCE_VIEW') && !checkPermission('ATTENDANCE_EDIT'),
    },
    {
        parent: 'attendance',
        show: false,
        href: '/time/time_reports',
        text: 'Time Log Report',
        noPermission: !checkPermission('ATTENDANCE_VIEW') && !checkPermission('ATTENDANCE_EDIT'),
    },
    {
        parent: 'attendance',
        show: false,
        href: '/time/weekly_monthly',
        text: 'Weekly/Monthly Report',
        noPermission: !checkPermission('ATTENDANCE_VIEW') && !checkPermission('ATTENDANCE_EDIT'),
    },
    {
        parent: 'attendance',
        show: false,
        href: '/time/work_policy',
        text: 'Work Schedule Settings',
        noPermission: !checkPermission('ATTENDANCE_POLICY_VIEW') && !checkPermission('ATTENDANCE_POLICY_EDIT'),
    },
    {
        children: true,
        img: 'flight-take-off',
        text: 'Leaves',
        noPermission: !checkPermission('LEAVE_VIEW') && !checkPermission('LEAVE_EDIT'),
    },
    {
        parent: 'flight-take-off',
        show: false,
        href: '/leave/leave_usage_history',
        text: 'Leave Usage History',
        noPermission: !checkPermission('LEAVE_VIEW') && !checkPermission('LEAVE_EDIT'),
    },
    {
        parent: 'flight-take-off',
        show: false,
        href: '/leave/grant_management',
        text: 'Manual Grant',
        noPermission: !checkPermission('LEAVE_VIEW') && !checkPermission('LEAVE_EDIT'),
    },
    {
        parent: 'flight-take-off',
        show: false,
        href: '/leave/leave_settings',
        text: 'Leave Settings',
        noPermission: !checkPermission('LEAVE_SETTING_VIEW') && !checkPermission('LEAVE_SETTING_EDIT'),
    },
    {
        children: true,
        img: 'description',
        text: 'Filing',
        noPermission: !checkPermission('FILING_EDIT'),
    },
    {
        parent: 'description',
        show: false,
        href: '/filing/approval_management',
        text: 'Approval Management',
        noPermission: !checkPermission('FILING_APPROVAL_EDIT'),
    },
    {
        parent: 'description',
        show: false,
        href: '/filing/filing_settings',
        text: 'Filing Settings',
        noPermission: !checkPermission('FILING_EDIT'),
    },
    {
        children: true,
        img: 'flexben',
        text: 'FlexBen',
        noPermission: !checkPermission('FLEXBEN_VIEW') && !checkPermission('FLEXBEN_EDIT') && !checkPermission('FLEXBEN_SUB_ADMIN_EDIT'),
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/summary',
        text: 'Summary',
        noPermission: !checkPermission('FLEXBEN_VIEW') && !checkPermission('FLEXBEN_EDIT'),
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/topup',
        text: 'Top up',
        noPermission: !checkPermission('FLEXBEN_VIEW') && !checkPermission('FLEXBEN_EDIT'),
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/transaction',
        text: 'Transfer/Deduct',
        noPermission: !checkPermission('FLEXBEN_EDIT')
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/sub_admin/transaction',
        text: checkPermission('FLEXBEN_EDIT') ? 'Transfer/Deduct<br>(Sub-admin)' : 'Transfer/Deduct',
        noPermission: !checkPermission('FLEXBEN_SUB_ADMIN_EDIT')
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/point_history',
        text: 'Point History',
        noPermission: !checkPermission('FLEXBEN_VIEW') && !checkPermission('FLEXBEN_EDIT') && !checkPermission('FLEXBEN_SUB_ADMIN_EDIT'),
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/flex_ben_setting',
        href_sub: ['/flex_ben/flex_ben_setting/add_flex_ben_type', '/flex_ben/flex_ben_setting/edit_flex_ben_type'],
        text: 'FlexBen Settings',
        noPermission: !checkPermission('FLEXBEN_EDIT'),
    },
    {
        children: true,
        img: 'paid',
        text: 'Payroll',
        // 둘 다 있어야 보이는 조건
        noPermission: !checkPermission('PAYROLL_SETTING_EDIT') || !checkSubscription('PAYROLL_USAGE'),
    },
    {
        parent: 'paid',
        show: false,
        href: '/payroll/payroll_processing',
        text: 'Payroll Processing',
        noPermission: !checkPermission('PAYROLL_SETTING_EDIT') || !checkSubscription('PAYROLL_USAGE'),
    },
    {
        parent: 'paid',
        show: false,
        href: '/payroll/payroll-report',
        text: 'Report',
        noPermission: !checkPermission('PAYROLL_SETTING_EDIT') || !checkSubscription('PAYROLL_USAGE'),
    },
    {
        parent: 'paid',
        show: false,
        href: '/payroll/payroll-settings',
        text: 'Settings',
        noPermission: !checkPermission('PAYROLL_SETTING_EDIT') || !checkSubscription('PAYROLL_USAGE'),
    },
    {
        parent: 'paid',
        show: false,
        href: '/payroll/payroll-rates-and-taxes',
        text: 'Rates & Taxes',
        noPermission: !checkPermission('PAYROLL_SETTING_EDIT') || !checkSubscription('PAYROLL_USAGE'),
    },
    {
        children: true,
        img: 'settings',
        text: 'Settings',
        // 둘 중 하나만 있으면 no permission
        noPermission: !checkPermission('SETTING_EDIT') && !checkPermission('COMPANY_SETTING_EDIT'),
    },
    {
        parent: 'settings',
        show: false,
        href: '/settings/company-settings',
        text: 'Company Settings',
        noPermission: !checkPermission('COMPANY_SETTING_EDIT'),
    },
    {
        parent: 'settings',
        show: false,
        href: '/settings/admin_settings',
        text: 'Admin Settings',
        noPermission: !checkPermission('SETTING_EDIT'),
    },
]);

const flexbenOnlyPages = reactive([
    {
        href: '/flex_ben/dashboard',
        img: 'dashboard',
        text: 'Dashboard',
    },
    {
        children: true,
        img: 'team',
        text: 'Team',
        noPermission: !checkPermission('TEAM_VIEW') && !checkPermission('TEAM_EDIT') && !checkPermission('TEAM_SETTING_VIEW') && !checkPermission('TEAM_SETTING_EDIT'),
    },
    {
        parent: 'team',
        show: false,
        href: checkPermission('TEAM_VIEW') || checkPermission('TEAM_EDIT') ? '/employees/employees' : '/employees/invited_employees',
        href_sub: ['/employees/invited_employees'],
        text: 'Employees',
        noPermission: !checkPermission('TEAM_VIEW') && !checkPermission('TEAM_EDIT') && !checkPermission('TEAM_SETTING_VIEW') && !checkPermission('TEAM_SETTING_EDIT'),
    },
    {
        parent: 'team',
        show: false,
        href: '/organization/department',
        href_sub: ['/organization/job_title'],
        text: 'Organization',
        noPermission: !checkPermission('TEAM_SETTING_VIEW') && !checkPermission('TEAM_SETTING_EDIT'),
    },
    {
        children: true,
        img: 'flexben',
        text: 'FlexBen',
        noPermission: !checkPermission('FLEXBEN_VIEW') && !checkPermission('FLEXBEN_EDIT') && !checkPermission('FLEXBEN_SUB_ADMIN_EDIT')
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/topup',
        text: 'Top up',
        noPermission: !checkPermission('FLEXBEN_VIEW') && !checkPermission('FLEXBEN_EDIT'),
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/transaction',
        text: 'Transfer/Deduct',
        noPermission: !checkPermission('FLEXBEN_EDIT')
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/sub_admin/transaction',
        text: checkPermission('FLEXBEN_EDIT') ? 'Transfer/Deduct<br>(Sub-admin)' : 'Transfer/Deduct',
        noPermission: !checkPermission('FLEXBEN_SUB_ADMIN_EDIT')
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/point_history',
        text: 'Point History',
        noPermission: !checkPermission('FLEXBEN_VIEW') && !checkPermission('FLEXBEN_EDIT') && !checkPermission('FLEXBEN_SUB_ADMIN_EDIT')
    },
    {
        parent: 'flexben',
        show: false,
        href: '/flex_ben/flex_ben_setting',
        href_sub: ['/flex_ben/flex_ben_setting/add_flex_ben_type', '/flex_ben/flex_ben_setting/edit_flex_ben_type'],
        text: 'FlexBen Settings',
        noPermission: !checkPermission('FLEXBEN_EDIT'),
    },
    /*=== shell전용 메뉴 ===*/
    {
        children: true,
        img: 'flexben-shell',
        text: 'FlexBen',
        noPermission: !checkPermission('FLEXBEN_VIEW_SHELL') && !checkPermission('FLEXBEN_EDIT_SHELL') && !checkPermission('FLEXBEN_SUB_ADMIN_EDIT_SHELL'),
    },
    {
        parent: 'flexben-shell',
        show: false,
        href: '/flex_ben_shell/summary',
        text: 'Summary',
        noPermission: !checkPermission('FLEXBEN_VIEW_SHELL') && !checkPermission('FLEXBEN_EDIT_SHELL'),
    },
    {
        parent: 'flexben-shell',
        show: false,
        href: '/flex_ben_shell/topup',
        text: 'Top up',
        noPermission: !checkPermission('FLEXBEN_VIEW_SHELL') && !checkPermission('FLEXBEN_EDIT_SHELL'),
    },
    {
        parent: 'flexben-shell',
        show: false,
        href: '/flex_ben_shell/transfer',
        text: 'Transfer',
        noPermission: !checkPermission('FLEXBEN_EDIT_SHELL')
    },
    {
        parent: 'flexben-shell',
        show: false,
        href: '/flex_ben_shell/sub_admin/transfer',
        text: checkPermission('FLEXBEN_EDIT_SHELL') ? 'Transfer<br>(Sub-admin)' : 'Transfer',
        noPermission: !checkPermission('FLEXBEN_SUB_ADMIN_EDIT_SHELL')
    },
    {
        parent: 'flexben-shell',
        show: false,
        href: '/flex_ben_shell/cancel',
        text: 'Cancel',
        noPermission: !checkPermission('FLEXBEN_EDIT_SHELL')
    },
    {
        parent: 'flexben-shell',
        show: false,
        href: '/flex_ben_shell/sub_admin/cancel',
        text: checkPermission('FLEXBEN_EDIT_SHELL') ? 'Cancel<br>(Sub-admin)' : 'Cancel',
        noPermission: !checkPermission('FLEXBEN_SUB_ADMIN_EDIT_SHELL')
    },
    {
        parent: 'flexben-shell',
        show: false,
        href: '/flex_ben_shell/point_history',
        text: 'Point History',
        noPermission: !checkPermission('FLEXBEN_VIEW_SHELL') && !checkPermission('FLEXBEN_EDIT_SHELL') && !checkPermission('FLEXBEN_SUB_ADMIN_EDIT_SHELL'),
    },
    {
        parent: 'flexben-shell',
        show: false,
        href: '/flex_ben_shell/flex_ben_setting',
        href_sub: ['/flex_ben_shell/flex_ben_setting/add_flex_ben_type', '/flex_ben_shell/flex_ben_setting/edit_flex_ben_type'],
        text: 'FlexBen Settings',
        noPermission: !checkPermission('FLEXBEN_EDIT_SHELL'),
    },
    /*=================================================*/
    {
        children: true,
        img: 'settings',
        text: 'Settings',
        // 둘 중 하나만 있으면 no permission
        noPermission: !checkPermission('SETTING_EDIT') && !checkPermission('COMPANY_SETTING_EDIT'),
    },
    {
        parent: 'settings',
        show: false,
        href: '/settings/company-settings',
        text: 'Company Settings',
        noPermission: !checkPermission('COMPANY_SETTING_EDIT'),
    },
    {
        parent: 'settings',
        show: false,
        href: '/settings/admin_settings',
        text: 'Admin Settings',
        noPermission: !checkPermission('SETTING_EDIT'),
    },
]);

// side menu 분리
let items = checkSubscription('FLEXBEN_ONLY_USAGE') ? flexbenOnlyPages : hrnflexPages;
// 열린 1차 메뉴의 key(img)를 저장
const openedMenus = reactive([]); 

onMounted(() => {
    const splitPathPure = window.location.pathname;

    const page = `${splitPathPure}`;
    let parent = '';

    items.forEach((item, index) => {
        var isEq = item['href'] && (item['href'] === page || item['href'] + '/' === page);
        if (typeof item['href_sub'] === 'object' && item['href_sub'].length) {
            const find1 = item['href_sub'].find((element) => {
                return element === page || element + '/' === page;
            });
            if (find1) isEq = true;
        }

        if (isEq) {
            items[index]['show'] = true;
            items[index]['isCurrentHref'] = true;
            parent = item['parent'];
        }
    });
    items.forEach((item, index) => {
        if (item['parent'] === parent) {
            items[index].show = true;
        }
    });
});

function clickIcon(clickedItem) {
    if (!clickedItem.children) {
        location.href = clickedItem.href;
        return;
    }

    const parentKey = clickedItem.img;
    const childItems = items.filter(item => item.parent === parentKey);
    const isCurrentlyOpen = childItems.some(item => item.show);

    // 닫기
    if (isCurrentlyOpen) {
        childItems.forEach(item => item.show = false);
        const idx = openedMenus.indexOf(parentKey);
        if (idx !== -1) {
            openedMenus.splice(idx, 1);
        }
        return;
    }

    // 최대 2개 초과 시 가장 오래된 메뉴 닫기
    if (openedMenus.length >= 2) {
        const oldest = openedMenus.shift();
        const oldChildItems = items.filter(item => item.parent === oldest);
        oldChildItems.forEach(item => item.show = false);
    }

    // 열기
    childItems.forEach(item => item.show = true);
    openedMenus.push(parentKey);

    // 메뉴 닫힘 상태면 열기
    if (!show.value) {
        show.value = true;
    }
}

function isCollapsedAndHasCurrentChild(item) {
    const parentKey = item.img;
    const childItems = items.filter(child => child.parent === parentKey);

    const isAnyChildOpen = childItems.some(child => child.show);
    const hasCurrentChild = childItems.some(child => child.isCurrentHref);

    return !isAnyChildOpen && hasCurrentChild;
}

function toggleMenu() {
    show.value = !show.value;
}

function isActiveParentMenu(clickedItem) {
    if (clickedItem.parent) {
        return false;
    }

    // 현재 주소와 일치하면 현재 메뉴
    if (clickedItem.isCurrentHref) {
        return true;
    }

    // 자식 중 하나라도 현재 URL에 해당하면 부모 메뉴 활성화로 간주
    const img = clickedItem.img;
    const hasActiveChild = items.some((item) => item.parent === img && item.isCurrentHref);
    return hasActiveChild;
}
</script>

<style lang="css" scoped>
.aside-scroll{
    height:calc(100vh - 5.25rem);
    overflow-y: scroll;
}
.aside-scroll::-webkit-scrollbar {
    width:6px;
    padding-left: 1rem;
    box-sizing: border-box;
}
.aside-scroll::-webkit-scrollbar-thumb {
    background-color: rgba(23,23,23,.4);
    border-radius: 8px;

}
</style>